module.exports = __webpack_public_path__ + "img/product_type1.b8e09651.png";